import moment from 'moment';

// Fecha de entrega que trae el documento del ERP (Bsale: atributo "Fecha de entrega" o
// "Fecha de despacho"). Solo se muestra: el pedido se planifica por ship_date. Se
// resalta cuando no es el dia del pedido, que es justo cuando hay que mirarla.
// La usan Pedidos y Planificacion.
//
// Mercado Libre llega por el mismo campo con la entrega que le prometio al comprador; a veces
// trae ventana horaria (`erp_delivery_window`, "19:00–23:00"), que va junto a la fecha.
//
// Si ML trae plazo de despacho (`meli_dispatch_limit`, el "Despachar: vie 16/oct antes de
// 16:30 hs" de la etiqueta) se muestra eso en vez de la entrega: es lo que la bodega tiene que
// cumplir. Va con el offset que manda ML (hora de Chile), sin pasarlo a la zona del navegador.
//
// En Flex no se muestra nada: el horario lo maneja Mercado Libre y no es algo que la bodega mire.
//
// `texto` ya trae el prefijo ("Entrega ..." o "Despachar ...").
export const erpDeliveryInfo = (o) => {
    if (String(o?.logistic_type || '').toLowerCase().trim() === 'self_service') return null;
    if (o?.meli_dispatch_limit) {
        const limite = moment.parseZone(o.meli_dispatch_limit);
        if (limite.isValid()) {
            // Verde si ya se finalizo; gris si se elimino o cancelo (ya no hay que despacharlo);
            // rojo si paso el plazo y sigue abierto; naranjo mientras corre el plazo.
            const cerrado = ['deleted', 'cancelled'].includes(o.state);
            const vencido = !cerrado && o.state !== 'finished' && limite.isBefore(moment());
            let color = 'warning.main';
            if (o.state === 'finished') color = 'success.main';
            else if (cerrado) color = 'text.secondary';
            else if (vencido) color = 'error.main';
            return {
                texto: `Despachar ${limite.format('DD MMM')} antes de ${limite.format('HH:mm')}`,
                titulo: 'Plazo de despacho de Mercado Libre',
                color,
            };
        }
    }
    if (!o?.erp_delivery_date) return null;
    const fecha = moment.utc(o.erp_delivery_date);
    const distinta = !fecha.isSame(moment.utc(o.ship_date), 'day');
    const deMeli = o.source_system === 'meli' || /Mercado Libre/.test(o.erp_delivery_date_label || '');
    return {
        texto: ['Entrega', fecha.format('DD MMM'), o.erp_delivery_window].filter(Boolean).join(' '),
        titulo: deMeli
            ? (o.erp_delivery_date_label || 'Entrega prometida por Mercado Libre')
            : `${o.erp_delivery_date_label || 'Fecha de entrega'} (según el ERP)`,
        color: distinta ? 'warning.main' : 'text.secondary',
    };
};
